// Detect environment based on hostname
const getEnvironmentConfig = () => {
  const hostname = window.location.hostname;
  const localAppScheme = process.env.NODE_ENV === 'development' && process.env.REACT_APP_LOCAL_APP_VARIANT === 'preview'
    ? 'vibesplit-preview'
    : 'vibesplit-dev';

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return {
      // CRA and the isolated web preview both proxy these paths locally.
      apiBaseUrl: `${window.location.origin}/api`,
      websocketUrl: `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`,
      environment: 'local',
      // Deep links from a local/dev web build target the DEV app build.
      deepLinkScheme: localAppScheme
    };
  }

  // Development server
  if (hostname === 'dev.vibesplit.xyz') {
    return {
      apiBaseUrl: 'https://dev.vibesplit.xyz/api',
      websocketUrl: 'wss://dev.vibesplit.xyz',
      environment: 'development',
      deepLinkScheme: 'vibesplit-dev'
    };
  }

  // Local dev server reached via a tunnel (ngrok/cloudflared) for on-device
  // testing — i.e. an unknown host while running `react-scripts start`. Route
  // the API at same-origin "/api" so it goes through the dev proxy
  // (src/setupProxy.js → localhost:3002), hitting the LOCAL backend instead of
  // prod. This is dev-server only: `react-scripts build` sets NODE_ENV to
  // 'production', so this branch is compiled out of every deployed build, and
  // the known hosts above are matched first regardless.
  if (process.env.NODE_ENV === 'development') {
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return {
      apiBaseUrl: '/api',
      websocketUrl: `${wsProtocol}//${window.location.host}`,
      environment: 'local',
      deepLinkScheme: localAppScheme
    };
  }

  // Production server (default)
  return {
    apiBaseUrl: 'https://vibesplit.xyz/api',
    websocketUrl: 'wss://vibesplit.xyz',
    environment: 'production',
    deepLinkScheme: 'vibesplit'
  };
};

const config = getEnvironmentConfig();

// Log current environment for debugging
console.log('🌐 Frontend Environment Config:');
console.log(`   Hostname: ${window.location.hostname}`);
console.log(`   Environment: ${config.environment}`);
console.log(`   API: ${config.apiBaseUrl}`);

export default config;
